import React from 'react';
import { TrackedLink as Link } from 'components/common/TrackedLink';
import take from 'lodash/fp/take';
import { useToggle } from 'hooks/useToggle';
import styled from 'styled-components';
import { CEB_COLOR, CEB_COLOR_RGBA } from 'app-constants/CEB_COLOR';
import { CaseLink } from 'features/link-helpers/CaseLink';

export const CitationResultsSnippets = ({ snippets, judicataId, query }) => {
  const [showMore, toggleMore] = useToggle();

  return (
    <StyledResultSnippet>
      {take(!showMore ? 2 : snippets.length)(snippets).map((snippet, i) => (
        <React.Fragment key={i}>
          <CaseLink
            judicataId={judicataId}
            hash={snippet.position}
            query={query}
            dangerouslySetInnerHTML={{
              __html: snippet.text,
            }}
          />
        </React.Fragment>
      ))}

      {snippets.length > 2 ? (
        <a href="#" className="toggle-more" onClick={toggleMore}>
          {showMore ? 'hide' : `and ${snippets.length - 2} more`}
        </a>
      ) : null}
    </StyledResultSnippet>
  );
};

const StyledResultSnippet = styled.span`
  display: inline;
  font-size: 16px;
  line-height: 1.5;
  a {
    color: inherit;
    &:hover {
      text-decoration: underline;
    }
    .citation-container {
      color: ${CEB_COLOR_RGBA('BLACK', 0.61)};
      display: block;
      margin-bottom: 0.5em;
    }
  }
  b {
    font-weight: inherit;
    background-color: ${CEB_COLOR('CITRINE_WHITE')};
  }
  .toggle-more {
    color: ${CEB_COLOR('DOVE_GRAY')};
    font-style: italic;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
